document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.directory-section');
    if (!section) return;

    const buttons = section.querySelectorAll('.alphabet-filter button');
    const cards = section.querySelectorAll('.directory-card');
    const search = section.querySelector('.directory-search');

    buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
            // Active state
            buttons.forEach((b) => b.classList.remove('active'));
            btn.classList.add('active');

            const letter = btn.dataset.letter.toLowerCase();

            cards.forEach((card) => {
                const title = card.dataset.title;
                const wrapper = card.closest('div'); // IMPORTANT (see below)

                if (letter === 'all' || title.startsWith(letter)) {
                    wrapper.style.display = '';
                } else {
                    wrapper.style.display = 'none';
                }
            });
        });
    });

    const clearBtn = section.querySelector('.directory-search-clear');

    search.addEventListener('input', () => {
        const value = search.value.toLowerCase();

        // Toggle clear button
        clearBtn.style.display = value ? 'block' : 'none';

        // Filter cards
        cards.forEach((card) => {
            card.closest('div').style.display =
                card.dataset.title.includes(value) ? '' : 'none';
        });
    });

    clearBtn.addEventListener('click', () => {
        search.value = '';
        clearBtn.style.display = 'none';

        // Show all cards
        cards.forEach((card) => {
            card.closest('div').style.display = '';
        });

        // Reset alphabet to "All"
        buttons.forEach((b) => b.classList.remove('active'));
        section
            .querySelector('.alphabet-filter button[data-letter="all"]')
            .classList.add('active');

        search.focus();
    });


});
